export const LabCaseCard = {
  flow: 'y',
  gap: 'Z',
  padding: 'A',
  round: 'A',
  background: 'inkMid',
  border: '1px solid inkBorder',
  HeaderRow: {
    flow: 'x',
    align: 'center space-between',
    CaseNumber: {
      text: (el, s) => s.caseId || 'LC-0001',
      fontSize: 'Z',
      fontWeight: '700',
      color: 'inkText'
    },
    CaseStatus: {
      tag: 'span',
      text: (el, s) => s.status || 'Impression Sent',
      fontSize: 'Y',
      fontWeight: '600',
      padding: 'X Z',
      round: 'B',
      background: (el, s) => {
        const st = s.status || ''
        if (st === 'Impression Sent') return 'blue.15'
        if (st === 'In Fabrication') return 'amber.15'
        if (st === 'Quality Check') return 'teal.15'
        if (st === 'Try-in Scheduled') return 'purple.15'
        if (st === 'Ready for Pickup') return 'green.15'
        return 'inkSurface'
      },
      color: (el, s) => {
        const st = s.status || ''
        if (st === 'Impression Sent') return 'blue'
        if (st === 'In Fabrication') return 'amber'
        if (st === 'Quality Check') return 'teal'
        if (st === 'Try-in Scheduled') return 'purple'
        if (st === 'Ready for Pickup') return 'green'
        return 'inkMuted'
      }
    }
  },
  PatientName: {
    text: (el, s) => s.patientName || 'Patient Name',
    fontSize: 'A',
    fontWeight: '600',
    color: 'inkText'
  },
  ProcedureType: {
    text: (el, s) => s.type || 'Crown - PFM',
    fontSize: 'Z',
    color: 'inkMuted'
  },
  LabVendor: {
    text: (el, s) => 'Lab: ' + (s.labVendor || 'Premier Dental Lab'),
    fontSize: 'Z',
    color: 'inkMuted'
  },
  DatesRow: {
    flow: 'x',
    gap: 'Z',
    flexWrap: 'wrap',
    DateSent: {
      text: (el, s) => 'Sent: ' + (s.dateSubmitted || '--'),
      fontSize: 'Y',
      color: 'inkSubtle'
    },
    EstimatedReturn: {
      text: (el, s) => 'Est: ' + (s.dateExpected || '--'),
      fontSize: 'Y',
      color: 'inkSubtle'
    },
    ActualReturn: {
      if: (el, s) => !!s.actualReturn,
      text: (el, s) => 'Actual: ' + (s.actualReturn || ''),
      fontSize: 'Y',
      color: 'green'
    }
  },
  Notes: {
    if: (el, s) => !!s.notes,
    text: (el, s) => s.notes,
    fontSize: 'Y',
    color: 'inkSubtle',
    fontStyle: 'italic'
  }
}
